import { PDFDocument } from 'pdf-lib';

export const compressPdf = async (file) => {
    try {
        const arrayBuffer = await file.arrayBuffer();

        // Load the PDF
        const pdfDoc = await PDFDocument.load(arrayBuffer);

        // Save the PDF. PDF-Lib optimizes by default when saving, 
        // removing unused objects and restructuring the file.
        // useObjectStreams: false is sometimes used for compatibility, 
        // but default (true) is better for size.
        const pdfBytes = await pdfDoc.save();

        // Create a blob from the bytes
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        return blob;
    } catch (error) {
        console.error("Error compressing PDF:", error);
        throw new Error("Failed to compress PDF. Please try again.");
    }
};
